import React, { useState } from 'react';

export default function AiForm({ onSubmit, loading }) {
  const [text, setText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = text.trim();

    if (!trimmed) return;

    // call your submit handler
    const result = onSubmit(trimmed);

    // if onSubmit returns a Promise, clear when it resolves
    if (result && typeof result.then === 'function') {
      result
        .then(() => setText(''))
        .catch(() => {
          // you could surface an error message here if desired
        });
    } else {
      // otherwise clear immediately
      setText('');
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="g-brd-around g-brd-gray-light-v4 g-pa-30"
      aria-label="Ask a biblical question form"
    >
      <div className="form-group g-mb-15">
        <label
          htmlFor="ai-question"
          className="g-font-size-12 g-color-gray-dark-v2 text-uppercase g-font-weight-600"
        >
          Ask a question
        </label>
        <p className="g-font-size-12 g-color-gray-dark-v5 g-mb-10">
          Share a question about the Bible, faith, or Christian living. The AI assistant
          will respond using biblical principles and insights.
        </p>
      </div>

      <div className="form-group g-mb-30">
        <textarea
          id="ai-question"
          className="form-control form-control-md g-resize-none rounded-0"
          rows="6"
          required
          placeholder="Enter your question or request here…"
          value={text}
          onChange={(e) => setText(e.target.value)}
          disabled={loading}
        />
      </div>

      <button
        type="submit"
        className="btn btn-md u-btn-primary rounded-0"
        disabled={loading || !text.trim()}
      >
        {loading ? 'Submitting…' : 'Ask Now'}
      </button>
    </form>
  );
}
